import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import SocialSharing from "vue-social-sharing";
import VueObserveVisibility from "vue-observe-visibility";
import VueCollapse from "vue2-collapse";
import VueNumber from "vue-number-animation";
// import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";
// import axios from "axios";

Vue.use(VueNumber);
Vue.use(VueMeta);

// get analytics ID from CMS
// axios
//   .get("https://api.riseapart.com/configuration")
//   .then(function(res) {
//     var analyticsID = res.data.data.filter(obj => {
//       return obj.key === "GOOGLE_ANALYTICS";
//     });
//
//     Vue.use(VueGtag, {
//       config: { id: analyticsID[0].defaultValue }
//     });
//   })
//   .catch(function(error) {
//     console.log("Error", error);
//   });


// Loading the plugin into the Vue.
Vue.use(VueCollapse);

Vue.use(SocialSharing);
Vue.use(VueObserveVisibility);

export const bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
